export default __webpack_public_path__ + "static/media/socialringlogo.5440bdee.png";